module.exports = __webpack_public_path__ + "img/12-02_Monitoring Work.f05003c4.svg";